/* Shirtwascash self-serve customer care: returns/exchanges portal and contact form. */
(function () {
  'use strict';

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(amount) { return '$' + Number(amount).toFixed(2).replace(/\.00$/, ''); }

  function api(base, path, body) {
    return fetch(base + path, body ? {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    } : undefined).then(function (response) {
      return response.json().catch(function () { return { ok: false, message: 'Something went wrong. Please try again.' }; });
    }, function () {
      return { ok: false, message: "We couldn't reach our system. Please try again, or email zen@thatshirtwascash.com." };
    });
  }

  function whenTurnstile(callback) {
    if (window.turnstile) return callback(window.turnstile);
    setTimeout(function () { whenTurnstile(callback); }, 100);
  }

  function humanCheck(slot, siteKey) {
    var state = { token: null, id: null };
    whenTurnstile(function (turnstile) {
      state.id = turnstile.render(slot, {
        sitekey: siteKey,
        theme: 'light',
        callback: function (token) { state.token = token; },
        'expired-callback': function () { state.token = null; },
      });
    });
    state.reset = function () {
      state.token = null;
      if (state.id !== null && window.turnstile) window.turnstile.reset(state.id);
    };
    return state;
  }

  // Each step slides in; the skeleton in the section markup holds the space until the first one.
  function paint(target, html) {
    target.innerHTML = html;
    target.classList.remove('is-entering');
    void target.offsetWidth;
    target.classList.add('is-entering');
  }

  function error(el, message) {
    el.textContent = message || '';
    el.hidden = !message;
  }

  // ---------- Returns portal ----------

  var PRIMARY = 'global-button global-button--primary';
  var SECONDARY = 'global-button global-button--secondary';
  var STAGES = {
    submitted: { chip: 'Waiting for your package', title: 'Waiting for your package', text: 'Print your label, tape it to the package and drop it off. We start as soon as the carrier scans it.' },
    review: { chip: 'Being reviewed', title: "We're taking a look", text: "We'll email you within one business day. No need to send anything yet." },
    shipped: { chip: 'On its way to us', title: 'Your return is on its way', text: "We're on it. You'll get an email as soon as it's done." },
    keeping: { chip: 'Being processed', title: 'No need to send anything', text: "Keep it. We're processing your request now." },
    done: { chip: 'Done', title: 'All set', text: '' },
  };

  function date(value) {
    return new Date(value).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
  }
  // "Nov 9–11" (or "Nov 29 – Dec 2" across months).
  function range(window) {
    var from = new Date(window.from + 'T12:00:00'), to = new Date(window.to + 'T12:00:00');
    var month = function (d) { return d.toLocaleDateString('en-US', { month: 'short' }); };
    if (window.from === window.to) return month(from) + ' ' + from.getDate();
    return month(from) === month(to) ? month(from) + ' ' + from.getDate() + '–' + to.getDate()
      : month(from) + ' ' + from.getDate() + ' – ' + month(to) + ' ' + to.getDate();
  }

  function dateTime(value) {
    return new Date(value).toLocaleString(undefined, { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
  }
  function itemLine(item) {
    var what = item.resolution === 'Exchange' && item.new_size ? 'Exchange → ' + esc(item.new_size) : esc(item.resolution);
    return esc(item.title) + (item.variant_title ? ' (' + esc(item.variant_title) + ')' : '') + ' · ' + what;
  }

  // A next-order code with copy, countdown and a shop link (returns and order changes).
  function couponBox(discount) {
    if (!discount) return '';
    return '<div class="swc-cs__coupon">' +
      '<span class="swc-cs__coupon-off">' + discount.percent + '% off your next order</span>' +
      '<button type="button" class="swc-cs__coupon-code" data-copy="' + esc(discount.code) + '">' + esc(discount.code) + '</button>' +
      '<span class="swc-cs__muted" data-countdown="' + esc(discount.ends_at) + '"></span>' +
      '<a class="' + PRIMARY + '" href="/discount/' + encodeURIComponent(discount.code) + '?redirect=/collections/all">Shop with this code</a>' +
    '</div>';
  }

  function wire(container) {
    container.querySelectorAll('[data-copy]').forEach(function (button) {
      button.addEventListener('click', function () {
        navigator.clipboard.writeText(button.dataset.copy).then(function () {
          var was = button.textContent;
          button.textContent = 'Copied';
          setTimeout(function () { button.textContent = was; }, 1500);
        });
      });
    });
    container.querySelectorAll('[data-share]').forEach(function (button) {
      button.addEventListener('click', function () {
        navigator.share({ title: 'My Shirtwascash return', url: button.dataset.share }).catch(function () {});
      });
    });
    container.querySelectorAll('[data-countdown]').forEach(function (el) {
      function tick() {
        var left = Date.parse(el.dataset.countdown) - Date.now();
        if (left <= 0) { el.textContent = 'Expired'; return; }
        var hours = Math.floor(left / 3600000);
        var minutes = Math.floor((left % 3600000) / 60000);
        el.textContent = 'Expires in ' + hours + 'h ' + minutes + 'm';
        setTimeout(tick, 30000);
      }
      tick();
    });
  }

// A signed-in customer's orders to pick from (returns and edit/cancel pages), searchable past 4.
function orderList(body, orders, onPick, onOther) {
    paint(body,
      '<div class="swc-cs__card">' +
        '<h2>Your orders</h2>' +
        (orders.length > 4 ? '<input class="swc-cs__search" type="search" placeholder="Search by order number or product" data-search>' : '') +
        '<div class="swc-cs__orders" data-list></div>' +
        '<p class="swc-cs__error" data-error hidden></p>' +
        '<button class="swc-cs__link" type="button" data-other>Order placed with a different email?</button>' +
      '</div>');
    var list = body.querySelector('[data-list]');
    var errorEl = body.querySelector('[data-error]');
    function draw(query) {
      var q = (query || '').toLowerCase().replace(/^#/, '');
      var shown = orders.filter(function (o) { return !q || o.name.indexOf(q) !== -1 || o.search.toLowerCase().indexOf(q) !== -1; });
      list.innerHTML = shown.length ? shown.map(function (o, index) {
        return '<button type="button" class="swc-cs__order" data-order="' + esc(o.name) + '">' +
          '<span class="swc-cs__thumbs">' + (o.images.length ? o.images : [null]).map(function (src) {
            return src ? '<img src="' + esc(src) + '" alt=""' + (index > 7 ? ' loading="lazy"' : '') + '>' : '<span class="swc-cs__noimg"></span>';
          }).join('') + '</span>' +
          '<span class="swc-cs__order-text"><strong>#' + esc(o.name) + '</strong>' +
            '<span class="swc-cs__muted">' + esc(o.date) + ' · ' + esc(o.total) + ' · ' + o.count + ' item' + (o.count === 1 ? '' : 's') + '</span>' +
            '</span>' +
          '<span class="swc-cs__chevron">›</span>' +
        '</button>';
      }).join('') : '<p class="swc-cs__muted">No orders match that.</p>';
    }
    draw('');
    var search = body.querySelector('[data-search]');
    if (search) search.addEventListener('input', function () { draw(search.value); });
    list.addEventListener('click', function (event) {
      var row = event.target.closest('[data-order]');
      if (row) onPick(row.dataset.order, errorEl, row);
    });
    body.querySelector('[data-other]').addEventListener('click', onOther);
  }

  function returnsPortal(root) {
    var base = root.dataset.api;
    var body = root.querySelector('[data-swc-body]');
    var ordersTag = root.querySelector('[data-swc-orders]');
    var orders = [];
    try { orders = ordersTag ? JSON.parse(ordersTag.textContent) : []; } catch (e) { orders = []; }
    var config, session, order;
    var requestId = new URLSearchParams(window.location.search).get('request');

    api(base, '/v1/config').then(function (cfg) {
      config = cfg;
      if (requestId) renderStatus(requestId);
      else if (orders.length) renderOrders();
      else renderLookup();
    });

    function start() { return orders.length ? renderOrders() : renderLookup(); }

    function lookup(number, email, errorEl, busy) {
      if (busy) busy.classList.add('is-busy');
      api(base, '/v1/lookup', { order_number: number, email: email }).then(function (result) {
        if (busy) busy.classList.remove('is-busy');
        if (!result.ok) return error(errorEl, result.message);
        session = result.session;
        order = result.order;
        draft = null;
        renderItems();
      });
    }

    function renderOrders() {
      orderList(body, orders, function (name, errorEl, row) { lookup(name, root.dataset.email, errorEl, row); }, renderLookup);
    }

    function renderLookup() {
      paint(body,
        '<form class="swc-cs__card" data-lookup>' +
          '<h2>Find your order</h2>' +
          '<label>Order number<input name="order_number" inputmode="numeric" autocomplete="off" placeholder="e.g. 81107" required></label>' +
          '<label>Email used for the order<input name="email" type="email" autocomplete="email" required value="' + esc(root.dataset.email) + '"></label>' +
          '<p class="swc-cs__error" data-error hidden></p>' +
          '<button class="' + PRIMARY + '" type="submit">Find my order</button>' +
          (orders.length ? '<button class="swc-cs__link" type="button" data-back>Back to your orders</button>' : '') +
        '</form>');
      var form = body.querySelector('[data-lookup]');
      if (orders.length) form.querySelector('[data-back]').addEventListener('click', renderOrders);
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        lookup(form.order_number.value, form.email.value, form.querySelector('[data-error]'), form.querySelector('button'));
      });
    }

    function reasonOptions() {
      return '<option value="">Why are you sending it back?</option>' + config.reasons.map(function (r) {
        return '<option value="' + esc(r.key) + '">' + esc(r.label) + '</option>';
      }).join('');
    }

    function requestRows(requests) {
      if (!requests || !requests.length) return '';
      return '<div class="swc-cs__requests"><h3>Requests on this order</h3>' + requests.map(function (r) {
        return '<a class="swc-cs__request" href="' + esc(r.status_url) + '">' +
          '<span><strong>' + esc(date(r.submitted_at)) + '</strong><span class="swc-cs__muted">' +
            r.items.map(itemLine).join('<br>') + '</span></span>' +
          '<span class="swc-cs__chip swc-cs__chip--' + esc(r.stage) + '">' + esc(STAGES[r.stage].chip) + '</span>' +
        '</a>';
      }).join('') + '</div>';
    }

    // The request being built: Return or Exchange, which items, and per item a reason,
    // a quantity and (exchanges) the new size. Kept here so "Go back" restores it.
    var draft;
    function freshDraft() { return { mode: 'return', money: null, ship: null, note: '', items: {} }; }

    function addressLine(a) {
      return esc(a.name) + ', ' + esc(a.street1) + ' ' + esc(a.street2) + ', ' + esc(a.city) + ', ' + esc(a.state) + ' ' + esc(a.zip) + ', USA';
    }

    // Customers shipping it back themselves (or another way than our label) add their tracking
    // here; the first scan starts processing.
    function trackingForm(requestId, prompt) {
      return '<form class="swc-cs__track" data-track="' + esc(requestId) + '">' +
        '<span class="swc-cs__label">' + esc(prompt || 'Shipped it? Add your tracking number') + '</span>' +
        '<div class="swc-cs__track-row"><input name="tracking_code" autocomplete="off" placeholder="Tracking number" required>' +
        '<button class="' + SECONDARY + '" type="submit">Add</button></div>' +
        '<p class="swc-cs__error" data-error hidden></p>' +
      '</form>';
    }

    function wireTracking(container, onDone) {
      container.querySelectorAll('[data-track]').forEach(function (form) {
        form.addEventListener('submit', function (event) {
          event.preventDefault();
          var button = form.querySelector('button');
          button.disabled = true;
          api(base, '/v1/tracking', { request_id: form.dataset.track, tracking_code: form.tracking_code.value }).then(function (result) {
            button.disabled = false;
            if (!result.ok) return error(form.querySelector('[data-error]'), result.message);
            onDone(result.request);
          });
        });
      });
    }

    function itemCard(item, index) {
      var noExchange = item.eligible && !item.exchange_options.length;
      var thumb = item.image ? '<img src="' + esc(item.image) + '" alt="">' : '<span class="swc-cs__noimg"></span>';
      return '<div class="swc-cs__item' + (item.eligible ? '' : ' is-disabled') + (noExchange ? ' no-exchange' : '') + '" data-index="' + index + '">' +
        '<div class="swc-cs__item-head"' + (item.eligible ? ' role="button" tabindex="0" data-toggle' : '') + '>' +
          thumb +
          '<div><strong>' + esc(item.title) + '</strong>' +
            (item.variant_title ? '<span class="swc-cs__muted">' + esc(item.variant_title) + '</span>' : '') +
            (item.eligible ? '' : '<span class="swc-cs__muted">' + esc(item.reason) + '</span>') +
            (noExchange ? '<span class="swc-cs__muted swc-cs__only-exchange">No other sizes available</span>' : '') +
          '</div>' +
          (item.eligible ? '<span class="swc-cs__check"></span>' : '') +
        '</div>' +
        (item.eligible
          ? '<div class="swc-cs__item-body">' +
              (item.quantity > 1
                ? '<label>How many?<select name="qty_' + index + '">' +
                  Array.from({ length: item.quantity }, function (_, n) { return '<option>' + (n + 1) + '</option>'; }).join('') +
                  '</select></label>'
                : '') +
              '<label>Reason<select name="reason_' + index + '">' + reasonOptions() + '</select></label>' +
              (item.exchange_options.length
                ? '<div class="swc-cs__only-exchange"><span class="swc-cs__label">New size</span><div class="swc-cs__sizes">' +
                  item.exchange_options.map(function (o) {
                    return '<button type="button" data-size="' + esc(o.variant_id) + '">' + esc(o.label) + '</button>';
                  }).join('') + '</div></div>'
                : '') +
            '</div>'
          : '') +
      '</div>';
    }

    function renderItems() {
      if (!draft) draft = freshDraft();
      var anyEligible = order.items.some(function (item) { return item.eligible; });
      paint(body,
        '<form class="swc-cs__card" data-items data-mode="' + draft.mode + '">' +
          '<h2>Order ' + esc(order.name) + '</h2>' +
          requestRows(order.requests) +
          (anyEligible
            ? '<div class="swc-cs__mode"><span class="swc-cs__mode-thumb"></span>' +
                '<button type="button" data-mode="return">Return</button><button type="button" data-mode="exchange">Exchange</button></div>' +
              '<p class="swc-cs__muted" data-hint></p>'
            : '') +
          '<div class="swc-cs__items">' + order.items.map(itemCard).join('') + '</div>' +
          (anyEligible && !order.prepaid_label
            ? '<div data-ship-box hidden><span class="swc-cs__label">Sending it back</span>' +
                '<div class="swc-cs__sizes swc-cs__sizes--wide">' +
                  '<button type="button" data-ship="customer_ships">Ship it back myself</button>' +
                  (order.keep_it_available
                    ? '<button type="button" data-ship="keep_it"><span class="swc-cs__only-return">Keep it, ' + order.keep_it_percent + '% store credit</span>' +
                      '<span class="swc-cs__only-exchange">Keep it, we ship the new size</span></button>'
                    : '') +
                '</div><p class="swc-cs__muted" data-ship-note></p></div>'
            : '') +
          (anyEligible
            ? '<div class="swc-cs__only-return swc-cs__money" data-money-box hidden><span class="swc-cs__label">Get your money back as</span>' +
                '<div class="swc-cs__sizes swc-cs__sizes--wide">' +
                  '<button type="button" data-money="refund">Original payment</button>' +
                  '<button type="button" data-money="store_credit">Store credit</button>' +
                '</div></div>' +
              '<label>Anything else we should know? (optional)<textarea name="note" rows="3" maxlength="2000"></textarea></label>' +
              '<p class="swc-cs__error" data-error hidden></p>' +
              '<button class="' + PRIMARY + '" type="submit">Review</button>'
            : '<p>Nothing on this order can be returned right now.</p>') +
          '<button class="swc-cs__link" type="button" data-back>Look up a different order</button>' +
        '</form>');
      var form = body.querySelector('[data-items]');
      form.querySelector('[data-back]').addEventListener('click', function () { draft = null; start(); });
      if (!anyEligible) return;
      var errorEl = form.querySelector('[data-error]');

      function sync() {
        form.dataset.mode = draft.mode;
        form.querySelector('[data-hint]').textContent = draft.mode === 'exchange'
          ? 'Tap the items you want in another size.' : 'Tap the items you want to send back.';
        form.querySelectorAll('[data-mode]').forEach(function (b) { b.classList.toggle('is-active', b.dataset.mode === draft.mode); });
        var any = false;
        form.querySelectorAll('[data-index]').forEach(function (row) {
          var pick = draft.items[row.dataset.index];
          row.classList.toggle('is-selected', Boolean(pick));
          if (!pick) return;
          any = true;
          row.querySelectorAll('[data-size]').forEach(function (b) { b.classList.toggle('is-active', b.dataset.size === pick.size); });
        });
        var shipBox = form.querySelector('[data-ship-box]');
        if (shipBox) {
          shipBox.hidden = !any;
          shipBox.querySelectorAll('[data-ship]').forEach(function (b) { b.classList.toggle('is-active', b.dataset.ship === draft.ship); });
          shipBox.querySelector('[data-ship-note]').textContent = draft.ship === 'keep_it'
            ? 'Keep it is a one-time option per customer.'
            : draft.ship === 'customer_ships' ? 'You pay the postage and add your tracking number after you ship.' : '';
        }
        form.querySelector('[data-money-box]').hidden = !(any && draft.mode === 'return' && draft.ship !== 'keep_it');
        form.querySelectorAll('[data-money]').forEach(function (b) { b.classList.toggle('is-active', b.dataset.money === draft.money); });
      }

      // Restore what was picked before "Go back".
      form.note.value = draft.note;
      Object.keys(draft.items).forEach(function (index) {
        var pick = draft.items[index];
        if (form['reason_' + index]) form['reason_' + index].value = pick.reason || '';
        if (form['qty_' + index]) form['qty_' + index].value = String(pick.qty || 1);
      });
      sync();

      form.addEventListener('click', function (event) {
        var modeButton = event.target.closest('[data-mode]');
        if (modeButton && modeButton.tagName === 'BUTTON') {
          if (modeButton.dataset.mode === draft.mode) return;
          draft.mode = modeButton.dataset.mode;
          draft.items = {};
          error(errorEl, '');
          var list = form.querySelector('.swc-cs__items');
          list.classList.remove('is-fading');
          void list.offsetWidth;
          list.classList.add('is-fading');
          return sync();
        }
        var size = event.target.closest('[data-size]');
        if (size) {
          draft.items[size.closest('[data-index]').dataset.index].size = size.dataset.size;
          return sync();
        }
        var money = event.target.closest('[data-money]');
        if (money) { draft.money = money.dataset.money; return sync(); }
        var ship = event.target.closest('[data-ship]');
        if (ship) { draft.ship = ship.dataset.ship; return sync(); }
        var head = event.target.closest('[data-toggle]');
        if (!head) return;
        var row = head.closest('[data-index]');
        if (draft.mode === 'exchange' && row.classList.contains('no-exchange')) return;
        var index = row.dataset.index;
        if (draft.items[index]) delete draft.items[index];
        else draft.items[index] = { reason: '', qty: 1, size: null };
        sync();
      });
      form.addEventListener('keydown', function (event) {
        if ((event.key === 'Enter' || event.key === ' ') && event.target.matches('[data-toggle]')) {
          event.preventDefault();
          event.target.click();
        }
      });
      form.addEventListener('change', function (event) {
        var row = event.target.closest('[data-index]');
        if (!row || !draft.items[row.dataset.index]) return;
        var pick = draft.items[row.dataset.index];
        if (event.target.name.indexOf('reason_') === 0) pick.reason = event.target.value;
        if (event.target.name.indexOf('qty_') === 0) pick.qty = Number(event.target.value);
      });
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        draft.note = form.note.value;
        var picks = [];
        var indexes = Object.keys(draft.items);
        for (var n = 0; n < indexes.length; n++) {
          var i = indexes[n];
          var item = order.items[i];
          var pick = draft.items[i];
          if (!pick.reason) return error(errorEl, 'Pick a reason for ' + item.title + '.');
          if (draft.mode === 'exchange' && !pick.size) return error(errorEl, 'Pick the new size for ' + item.title + '.');
          picks.push({
            line_item_id: item.line_item_id,
            title: item.title,
            quantity: pick.qty || 1,
            reason: pick.reason,
            resolution: draft.mode === 'exchange' ? 'exchange' : draft.ship === 'keep_it' ? 'store_credit' : draft.money,
            new_variant_id: draft.mode === 'exchange' ? pick.size : null,
            new_size: draft.mode === 'exchange'
              ? item.exchange_options.filter(function (o) { return o.variant_id === pick.size; })[0].label : null,
          });
        }
        if (!picks.length) return error(errorEl, draft.mode === 'exchange' ? 'Tap at least one item to exchange.' : 'Tap at least one item to return.');
        if (!order.prepaid_label && !draft.ship) return error(errorEl, 'Choose how you want to send it back.');
        if (draft.mode === 'return' && draft.ship !== 'keep_it' && !draft.money) return error(errorEl, 'Choose original payment or store credit.');
        renderReview(picks, draft.note);
      });
    }

    function outcome(picks) {
      var companyFault = picks.some(function (p) { return config.company_fault_reasons.indexOf(p.reason) !== -1; });
      var allExchange = picks.every(function (p) { return p.resolution === 'exchange'; });
      var fees = config.label_fee_usd[order.domestic ? 'domestic' : 'international'];
      var fee = companyFault ? fees.company_fault : allExchange ? fees.exchange : fees.customer_fault;
      return { companyFault: companyFault, fee: fee };
    }

    // What happens after submitting, only for what was picked.
    function notes(picks) {
      var has = function (kind) { return picks.some(function (p) { return p.resolution === kind; }); };
      var money = [has('refund') ? 'Refunds' : null, has('store_credit') ? 'store credit' : null].filter(Boolean).join(' and ');
      return [
        has('exchange') ? 'Exchanges ship once your return is on its way' : null,
        money ? money.charAt(0).toUpperCase() + money.slice(1) + ' go out when the carrier scans your return' : null,
        money ? "Original shipping isn't refundable" : null,
      ].filter(Boolean);
    }

    function renderReview(picks, note) {
      var result = outcome(picks);
      var address = config.return_address;
      var keepIt = !order.prepaid_label && draft.ship === 'keep_it';
      var next = result.companyFault
        ? "Sorry about that. We'll look at this personally and email you within one business day. No need to send anything yet."
        : keepIt
          ? (draft.mode === 'exchange'
            ? "Keep it, no need to send anything back. We'll ship your new size."
            : 'Keep it, no need to send anything back. You get ' + order.keep_it_percent + '% of the item price as store credit.')
        : order.prepaid_label
          ? 'You get a prepaid return label on the next screen.' +
            (result.fee ? ' A ' + money(result.fee) + ' return shipping fee comes out of your refund.' : ' Return shipping is free.')
          : 'Ship your items to ' + addressLine(address) + ' at your own cost, then add your tracking number on the next screen.' +
            (result.fee ? ' A ' + money(result.fee) + ' return fee comes out of your refund.' : '');
      var bullets = result.companyFault || keepIt ? [] : notes(picks);
      paint(body,
        '<div class="swc-cs__card">' +
          '<h2>Review your request</h2>' +
          '<ul class="swc-cs__summary">' + picks.map(function (p) {
            var what = p.resolution === 'exchange' ? 'Exchange for size ' + esc(p.new_size)
              : p.resolution === 'refund' ? 'Refund' : 'Store credit';
            return '<li><strong>' + esc(p.title) + (p.quantity > 1 ? ' × ' + p.quantity : '') + '</strong><span>' + what + '</span></li>';
          }).join('') + '</ul>' +
          '<p>' + next + '</p>' +
          (bullets.length ? '<ul class="swc-cs__bullets">' + bullets.map(function (b) { return '<li>' + esc(b) + '</li>'; }).join('') + '</ul>' : '') +
          '<p class="swc-cs__error" data-error hidden></p>' +
          '<button class="' + PRIMARY + '" type="button" data-submit>Submit</button>' +
          '<button class="swc-cs__link" type="button" data-back>Go back</button>' +
        '</div>');
      body.querySelector('[data-back]').addEventListener('click', renderItems);
      body.querySelector('[data-submit]').addEventListener('click', function (event) {
        var button = event.currentTarget;
        button.disabled = true;
        button.textContent = 'Submitting…';
        api(base, '/v1/returns', { session: session, items: picks, note: note, shipping: order.prepaid_label ? null : draft.ship }).then(function (response) {
          if (!response.ok) {
            button.disabled = false;
            button.textContent = 'Submit';
            return error(body.querySelector('[data-error]'), response.message);
          }
          renderDone(response);
        });
      });
    }

    // Ways to get the status link (label included) somewhere else, no SMS service needed.
    function shareRow(url) {
      var subject = encodeURIComponent('My Shirtwascash return');
      var text = encodeURIComponent('Return label and status: ' + url);
      return '<div class="swc-cs__share"><span class="swc-cs__muted">Send it to yourself</span>' +
        '<a href="mailto:?subject=' + subject + '&body=' + text + '">Email</a>' +
        '<a href="sms:?&body=' + text + '">Text</a>' +
        '<button type="button" data-copy="' + esc(url) + '">Copy link</button>' +
        (navigator.share ? '<button type="button" data-share="' + esc(url) + '">Share</button>' : '') +
      '</div>';
    }

    function footerButtons(statusUrl) {
      return '<div class="swc-cs__actions">' +
        (statusUrl ? '<a class="' + SECONDARY + '" href="' + esc(statusUrl) + '">Check status</a>' : '') +
        '<a class="' + SECONDARY + '" href="/pages/contact-us">Contact us</a>' +
      '</div>';
    }

    function renderDone(response) {
      var label = response.label;
      var message = response.decision === 'review'
        ? "We've got it. We'll email you within one business day with next steps."
        : label
          ? 'Print your label, tape it to the package and drop it off with ' + esc(label.carrier) + '. We start as soon as it gets its first scan.'
          : response.shipping === 'keep_it'
            ? "We've got it. Keep it, there's nothing to send back."
          : response.shipping === 'customer_ships'
            ? 'Ship your items to ' + addressLine(config.return_address) + '. Add your tracking number below and we start as soon as it\'s moving.'
            : "We've got it. Your return label will be emailed to you shortly.";
      paint(body,
        '<div class="swc-cs__card swc-cs__done">' +
          '<h2>Request received</h2>' +
          '<p>' + message + '</p>' +
          (label
            ? '<a class="' + PRIMARY + '" href="' + esc(label.url) + '" target="_blank" rel="noopener">Download return label</a>' +
              shareRow(response.status_url) +
              '<p class="swc-cs__muted">Tracking: ' + esc(label.carrier) + ' ' + esc(label.tracking_code) + '</p>'
            : '') +
          (response.shipping === 'customer_ships' && response.decision !== 'review' ? trackingForm(response.request_id) : '') +
          '<p class="swc-cs__muted">We also emailed you a copy.</p>' +
          couponBox(response.discount) +
          footerButtons(response.status_url) +
        '</div>');
      wire(body);
      wireTracking(body, function () { window.location.href = response.status_url; });
    }

    function renderStatus(id) {
      api(base, '/v1/status?id=' + encodeURIComponent(id)).then(function (result) {
        if (!result.ok) {
          paint(body, '<div class="swc-cs__card"><p>' + esc(result.message) + '</p>' +
            '<a class="swc-cs__link" href="' + window.location.pathname + '">Start a return or exchange</a></div>');
          return;
        }
        var r = result.request;
        var stage = STAGES[r.stage];
        var steps = ['Submitted', r.stage === 'review' ? 'Reviewing' : r.shipping === 'keep_it' ? 'Processing' : 'Shipped back', 'Done'];
        var reached = { submitted: 0, review: 1, shipped: 1, keeping: 1, done: 2 }[r.stage];
        var text = r.stage === 'done'
          ? esc(r.history[r.history.length - 1].text)
          : r.stage === 'submitted' && r.shipping === 'customer_ships'
            ? (r.customer_tracking
              ? "Thanks for the tracking number. We start as soon as it's moving."
              : 'Ship your items to ' + addressLine(r.return_address) + ', then add your tracking number below.')
          : r.stage === 'keeping' && r.keep_it_percent
            ? 'Keep it. Your ' + r.keep_it_percent + '% store credit is on its way.'
          : r.stage === 'keeping'
            ? "Keep it. We're shipping your new size."
            : stage.text;
        paint(body,
          '<div class="swc-cs__card">' +
            '<div class="swc-cs__status-head"><h2>Order ' + esc(r.order_name) + '</h2>' +
              '<span class="swc-cs__chip swc-cs__chip--' + esc(r.stage) + '">' + esc(stage.chip) + '</span></div>' +
            '<ol class="swc-cs__steps">' + steps.map(function (name, index) {
              return '<li class="' + (index < reached ? 'is-done' : index === reached ? 'is-current' : '') + '"><span></span>' + esc(name) + '</li>';
            }).join('') + '</ol>' +
            '<div><strong>' + esc(stage.title) + '</strong><p class="swc-cs__muted">' + text + '</p></div>' +
            '<dl class="swc-cs__facts">' +
              '<dt>Requested</dt><dd>' + esc(dateTime(r.submitted_at)) + '</dd>' +
              (r.label
                ? '<dt>Carrier</dt><dd>' + esc(r.label.carrier) + '</dd>' +
                  '<dt>Tracking</dt><dd>' + (r.label.tracking_url
                    ? '<a href="' + esc(r.label.tracking_url) + '" target="_blank" rel="noopener">' + esc(r.label.tracking_code) + '</a>'
                    : esc(r.label.tracking_code)) + '</dd>' +
                  '<dt>Label</dt><dd><a href="' + esc(r.label.url) + '" target="_blank" rel="noopener">Download</a></dd>'
                : '') +
              (r.refunds || []).map(function (f) {
                return '<dt>' + (f.kind === 'store_credit' ? 'Store credit' : 'Refunded') + '</dt><dd>' + esc(money(f.amount)) + ' on ' + esc(date(f.at)) + '</dd>';
              }).join('') +
            '</dl>' +
            ((r.refunds || []).some(function (f) { return f.kind === 'refund'; })
              ? '<p class="swc-cs__muted">Refunds go back to your original payment and show on your statement within 5-10 business days.</p>' : '') +
            (r.customer_tracking
              ? '<dl class="swc-cs__facts"><dt>Your tracking</dt><dd>' + esc(r.customer_tracking.tracking_code) + '</dd></dl>'
              : '') +
            ((r.shipping === 'customer_ships' || r.label) && r.stage === 'submitted' && !r.customer_tracking
              ? trackingForm(r.id, r.label ? 'Shipped it another way? Add your tracking number' : null) : '') +
            (r.label && r.stage === 'submitted' ? shareRow(r.status_url) : '') +
          '</div>' +
          '<div class="swc-cs__card"><h3>Items</h3>' + r.items.map(function (item) {
            return '<div class="swc-cs__item-head">' +
              (item.image ? '<img src="' + esc(item.image) + '" alt="" loading="lazy">' : '<span class="swc-cs__noimg"></span>') +
              '<div><strong>' + esc(item.title) + (item.quantity > 1 ? ' × ' + item.quantity : '') + '</strong>' +
                (item.variant_title ? '<span class="swc-cs__muted">' + esc(item.variant_title) + '</span>' : '') +
                '<span class="swc-cs__accent">' + (item.resolution === 'Exchange' && item.new_size ? 'Exchange → ' + esc(item.new_size) : esc(item.resolution)) + '</span>' +
                '<span class="swc-cs__muted">' + esc(item.reason) + '</span>' +
              '</div></div>';
          }).join('') + '</div>' +
          '<div class="swc-cs__card"><h3>History</h3><ul class="swc-cs__history">' + r.history.slice().reverse().map(function (h) {
            return '<li><span>' + esc(h.text) + '</span><span class="swc-cs__muted">' + esc(dateTime(h.at)) + '</span></li>';
          }).join('') + '</ul></div>' +
          (r.discount ? '<div class="swc-cs__card swc-cs__done">' + couponBox(r.discount) + '</div>' : '') +
          footerButtons(null));
        wire(body);
        wireTracking(body, function () { renderStatus(id); });
      });
    }
  }

  // ---------- Contact form ----------

  // The edit/cancel page: look up the order, see where it is and what can still change.
  // Cancel runs right away (the home server cancels and refunds within a minute) and the
  // page watches the order until it reads cancelled.
  function orderChange(root, base, body) {
    var session = null;
    var ordersTag = root.querySelector('[data-swc-orders]');
    var orders = [];
    try { orders = ordersTag ? JSON.parse(ordersTag.textContent) : []; } catch (e) { orders = []; }

    function open(number, email, errorEl, button) {
      if (button) { button.disabled = true; button.classList.add('is-busy'); }
      api(base, '/v1/order', { order_number: number, email: email }).then(function (result) {
        if (button) { button.disabled = false; button.classList.remove('is-busy'); }
        if (!result.ok) return error(errorEl, result.message);
        session = result.session;
        renderOrder(result.order);
      });
    }

    function renderOrders() {
      orderList(body, orders, function (name, errorEl, row) { open(name, root.dataset.email, errorEl, row); }, renderLookup);
    }
    var STAGES = {
      not_started: { chip: 'Not started', text: "We haven't started making it yet, so you can still cancel it, change a size or change the address." },
      in_production: { chip: 'Being made', text: "It's being made now, so it can't be cancelled and ships as ordered. You can still change the address until it ships." },
      shipped: { chip: 'Shipped', text: "It's on its way. Once it arrives you can start a return or exchange." },
      delivered: { chip: 'Delivered', text: 'It was delivered. You can start a return or exchange.' },
      cancelled: { chip: 'Cancelled', text: 'This order is cancelled and refunded to your original payment.' }
    };
    var STEP = { not_started: 0, in_production: 1, shipped: 2, delivered: 3 };

    function done(title, text) {
      paint(body, '<div class="swc-cs__card swc-cs__done"><h2>' + esc(title) + '</h2><p>' + esc(text) + '</p></div>');
    }

    function renderLookup() {
      paint(body,
        '<form class="swc-cs__card" data-lookup>' +
          '<h2>Find your order</h2>' +
          '<label>Order number<input name="order_number" inputmode="numeric" autocomplete="off" placeholder="e.g. 81107" required></label>' +
          '<label>Email used for the order<input name="email" type="email" autocomplete="email" required value="' + esc(root.dataset.email) + '"></label>' +
          '<p class="swc-cs__error" data-error hidden></p>' +
          '<button class="' + PRIMARY + '" type="submit">Find my order</button>' +
          '<button class="swc-cs__link" type="button" data-plain>Can\'t find it? Message us</button>' +
          (orders.length ? '<button class="swc-cs__link" type="button" data-back>Back to your orders</button>' : '') +
        '</form>');
      var form = body.querySelector('[data-lookup]');
      form.querySelector('[data-plain]').addEventListener('click', function () { plainContact(root, base, body); });
      if (orders.length) form.querySelector('[data-back]').addEventListener('click', renderOrders);
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        open(form.order_number.value, form.email.value, form.querySelector('[data-error]'), form.querySelector('button'));
      });
    }

    function renderOrder(order) {
      var stage = STAGES[order.stage];
      var reached = STEP[order.stage];
      var steps = ['Placed', 'Being made', 'Shipped', 'Delivered'];
      paint(body,
        '<div class="swc-cs__card">' +
          '<div class="swc-cs__status-head"><h2>Order ' + esc(order.name) + '</h2>' +
            '<span class="swc-cs__chip' + (order.stage === 'shipped' || order.stage === 'delivered' ? ' swc-cs__chip--shipped' : '') + '">' + esc(stage.chip) + '</span></div>' +
          (order.stage === 'cancelled' ? '' : '<ol class="swc-cs__steps" style="grid-template-columns: repeat(4, 1fr)">' + steps.map(function (name, index) {
            return '<li class="' + (index < reached ? 'is-done' : index === reached ? 'is-current' : '') + '"><span></span>' + esc(name) + '</li>';
          }).join('') + '</ol>') +
          '<p class="swc-cs__muted">' + esc(stage.text) + '</p>' +
          '<dl class="swc-cs__facts"><dt>Placed</dt><dd>' + esc(date(order.created_at)) + '</dd>' +
            (order.tracking ? '<dt>Tracking</dt><dd>' + (order.tracking.url
              ? '<a href="' + esc(order.tracking.url) + '" target="_blank" rel="noopener">' + esc(order.tracking.number) + '</a>'
              : esc(order.tracking.number)) + '</dd>' : '') +
            (order.delivered_at ? '<dt>Delivered</dt><dd>' + esc(date(order.delivered_at)) + '</dd>' : '') +
            (order.estimate && !order.delivered_at ? '<dt>Estimated delivery</dt><dd>' + esc(range(order.estimate)) + '</dd>' : '') +
            (order.latest_scan && !order.delivered_at ? '<dt>Latest scan</dt><dd>' + esc(order.latest_scan.text) + ' · ' + esc(date(order.latest_scan.at)) + '</dd>' : '') +
            (order.cancelled_items.length ? '<dt>Cancelled</dt><dd>' + esc(order.cancelled_items.map(function (item) {
              return item.title + (item.quantity > 1 ? ' × ' + item.quantity : '');
            }).join(', ')) + '</dd>' : '') +
            order.refunds.map(function (f) { return '<dt>Refunded</dt><dd>' + esc(money(f.amount)) + ' on ' + esc(date(f.at)) + '</dd>'; }).join('') +
          '</dl>' +
          (order.refunds.length ? '<p class="swc-cs__muted">Refunds go back to your original payment and show on your statement within 5-10 business days.</p>' : '') +
          (order.stuck ? '<div class="swc-cs__card"><strong>No tracking movement in ' + order.stuck.quiet_days + ' day' + (order.stuck.quiet_days === 1 ? '' : 's') + '</strong>' +
            '<p class="swc-cs__muted">Parcels sometimes go quiet while they change carriers. If it still looks stuck, tell us and we\'ll chase it or send a new one.</p>' +
            '<button class="' + SECONDARY + '" type="button" data-act="missing">Tell us it\'s stuck</button></div>' : '') +
          (order.stage === 'delivered' ? '<div class="swc-cs__card"><strong>Didn\'t get it?</strong>' +
            '<p class="swc-cs__muted">Check around your door, with neighbors and your mailroom. Carriers sometimes scan a parcel delivered a day early, so give it up to 48 hours.</p>' +
            (order.can_report_missing ? '<button class="' + SECONDARY + '" type="button" data-act="missing">It still hasn\'t arrived</button>' : '') + '</div>' : '') +
          order.items.map(function (item, index) {
            return '<div class="swc-cs__item-head" data-order-item>' +
              (item.image ? '<img src="' + esc(item.image) + '" alt="" loading="lazy">' : '<span class="swc-cs__noimg"></span>') +
              '<div><strong>' + esc(item.title) + (item.quantity > 1 ? ' × ' + item.quantity : '') + '</strong>' +
                (item.variant_title ? '<span class="swc-cs__muted">' + esc(item.variant_title) + '</span>' : '') +
                // Change size turns the size line into "XL → [new size]".
                (item.sizes && item.sizes.length ? '<label class="swc-cs__pick" data-swap="' + index + '" hidden>' + esc(item.variant_title || '') + ' →' +
                  '<select><option value="">Keep</option>' +
                  item.sizes.map(function (size) { return '<option value="' + esc(size.variant_id) + '">' + esc(size.label) + '</option>'; }).join('') +
                  '</select></label>' : '') +
              '</div></div>';
          }).join('') +
          '<div class="swc-cs__actions" data-actions>' +
            (order.can_cancel ? '<button class="' + SECONDARY + '" type="button" data-act="cancel">' + (units(order) > 1 ? 'Cancel item(s)' : 'Cancel order') + '</button>' : '') +
            (order.can_swap_size ? '<button class="' + SECONDARY + '" type="button" data-act="swap">Change size</button>' : '') +
            (order.can_change_address ? '<button class="' + SECONDARY + '" type="button" data-act="address">Change address</button>' : '') +
            (order.stage === 'in_production' ? '<button class="' + SECONDARY + '" type="button" data-act="remind">Wrong size or changed your mind?</button>' : '') +
            (order.stage === 'shipped' || order.stage === 'delivered'
              ? '<a class="' + SECONDARY + '" href="/pages/start-a-return">Start a return or exchange</a>' : '') +
            '<button class="' + SECONDARY + '" type="button" data-act="message">Something else</button>' +
          '</div>' +
          '<div data-panel></div>' +
          '<button class="swc-cs__link" type="button" data-back>' + (orders.length ? 'Back to your orders' : 'Look up another order') + '</button>' +
        '</div>');
      var panel = body.querySelector('[data-panel]');
      body.querySelector('[data-back]').addEventListener('click', orders.length ? renderOrders : renderLookup);
      var choices = body.querySelectorAll('[data-actions], [data-act]');
      // Picking a change swaps the buttons for that change's options; Back brings the buttons back
      // (and the item sizes, if Change size had opened them).
      function back() {
        choices.forEach(function (el) { el.hidden = false; });
        body.querySelectorAll('[data-order-item]').forEach(function (el) { el.hidden = false; });
        body.querySelectorAll('[data-swap]').forEach(function (row) {
          row.hidden = true;
          row.querySelector('select').value = '';
          row.previousElementSibling.hidden = false;
        });
        paint(panel, '');
      }
      body.querySelectorAll('[data-act]').forEach(function (button) {
        button.addEventListener('click', function () {
          var act = button.dataset.act;
          choices.forEach(function (el) { el.hidden = true; });
          // Cancel lists the items as its own tiles.
          if (act === 'cancel') body.querySelectorAll('[data-order-item]').forEach(function (el) { el.hidden = true; });
          if (act === 'cancel') cancelPanel(panel, order);
          else if (act === 'address') addressPanel(panel, order);
          else if (act === 'missing') missingPanel(panel, order);
          else if (act === 'remind') remindPanel(panel, order);
          else if (act === 'swap') swapPanel(panel, order);
          else messagePanel(panel);
          // Back sits next to the change's own button (wrapped into a button row when it stands alone).
          var link = document.createElement('button');
          link.type = 'button';
          link.className = SECONDARY;
          link.textContent = 'Back';
          link.addEventListener('click', back);
          var buttons = panel.querySelectorAll('.global-button--primary');
          var main = buttons[buttons.length - 1];
          if (!main) return panel.insertBefore(link, panel.firstChild);
          var row = main.parentNode;
          if (!row.classList.contains('swc-cs__actions')) {
            row = document.createElement('div');
            row.className = 'swc-cs__actions';
            main.parentNode.insertBefore(row, main);
            row.appendChild(main);
          }
          row.appendChild(link);
        });
      });
    }

    function send(payload, errorEl, button, onDone) {
      button.disabled = true;
      payload.session = session;
      api(base, '/v1/order/request', payload).then(function (result) {
        button.disabled = false;
        if (!result.ok) return error(errorEl, result.message);
        onDone(result);
      });
    }

    // The cancel is carried out on our side within a minute: the customer gets the outcome and a
    // next-order code right away.
    function cancelled(order, refund, items, result) {
      var amount = Number(refund) > 0 ? 'Your ' + money(refund) + ' refund' : 'Your refund';
      var text = items
        ? 'We cancelled ' + items + ' from order ' + order.name + '. ' + amount + ' goes back to your original payment within 5-10 business days, and a confirmation email is on the way. The rest of your order ships as usual.'
        : 'Order ' + order.name + ' is cancelled. ' + amount + ' goes back to your original payment within 5-10 business days, and a confirmation email is on the way.';
      paint(body, '<div class="swc-cs__card swc-cs__done"><h2>You\'re all set</h2><p>' + esc(text) + '</p>' + couponBox(result.discount) + '</div>');
      wire(body);
    }

    function units(order) {
      return order.items.reduce(function (sum, item) { return sum + item.quantity; }, 0);
    }

    // One item: a plain yes/no. Several: tap the items (or All items) to cancel, with a quantity
    // for lines of more than one, and the button shows the refund Shopify works out for the pick.
    function cancelPanel(panel, order) {
      if (units(order) === 1) {
        return confirmPanel(panel, order, 'Cancel order ' + order.name + '?',
          'Your full ' + money(order.total) + ' refund goes back to your original payment.', 'Yes, cancel it', null);
      }
      var picked = {};
      paint(panel,
        '<div class="swc-cs__card"><strong>Which items should we cancel?</strong>' +
          '<div class="swc-cs__items">' +
            '<div class="swc-cs__item" data-all><div class="swc-cs__item-head" role="button" tabindex="0" data-toggle>' +
              '<div><strong>All items</strong><span class="swc-cs__muted">Cancel the whole order</span></div><span class="swc-cs__check"></span></div></div>' +
            order.items.map(function (item, index) {
              return '<div class="swc-cs__item" data-index="' + index + '">' +
                '<div class="swc-cs__item-head" role="button" tabindex="0" data-toggle>' +
                  (item.image ? '<img src="' + esc(item.image) + '" alt="" loading="lazy">' : '<span class="swc-cs__noimg"></span>') +
                  '<div><strong>' + esc(item.title) + (item.quantity > 1 ? ' × ' + item.quantity : '') + '</strong>' +
                    '<span class="swc-cs__muted">' + esc([item.variant_title, money(item.price)].filter(Boolean).join(' · ')) + '</span></div>' +
                  '<span class="swc-cs__check"></span></div>' +
                (item.quantity > 1 ? '<div class="swc-cs__item-body"><label class="swc-cs__pick">How many?<select data-qty>' +
                  Array.apply(null, Array(item.quantity)).map(function (_, n) {
                    return '<option value="' + (n + 1) + '"' + (n + 1 === item.quantity ? ' selected' : '') + '>' + (n + 1) + '</option>';
                  }).join('') + '</select></label></div>' : '') +
              '</div>';
            }).join('') +
          '</div>' +
          '<p class="swc-cs__error" data-error hidden></p>' +
          '<div class="swc-cs__actions"><button class="' + PRIMARY + '" type="button" data-yes disabled>Pick items to cancel</button></div></div>');
      var yes = panel.querySelector('[data-yes]');
      var all = panel.querySelector('[data-all]');
      var asked = 0;
      var refund = null;

      function picks() {
        return order.items.map(function (item, index) {
          if (!picked[index]) return null;
          var qty = panel.querySelector('[data-index="' + index + '"] [data-qty]');
          return { id: item.id, quantity: qty ? Number(qty.value) : item.quantity };
        }).filter(Boolean);
      }

      function refresh() {
        order.items.forEach(function (_, index) {
          panel.querySelector('[data-index="' + index + '"]').classList.toggle('is-selected', Boolean(picked[index]));
        });
        var chosen = picks();
        var whole = chosen.length === order.items.length && chosen.every(function (pick, i) { return pick.quantity === order.items[i].quantity; });
        all.classList.toggle('is-selected', chosen.length === order.items.length);
        if (!chosen.length) { yes.disabled = true; yes.textContent = 'Pick items to cancel'; return; }
        var count = chosen.reduce(function (sum, pick) { return sum + pick.quantity; }, 0);
        var label = whole ? 'Cancel whole order' : 'Cancel ' + count + ' item' + (count > 1 ? 's' : '');
        yes.disabled = true;
        yes.textContent = label + ' · working out refund…';
        refund = null;
        var ask = ++asked;
        api(base, '/v1/order/refund', { session: session, items: chosen }).then(function (result) {
          if (ask !== asked) return;
          if (!result.ok) { yes.textContent = label; return error(panel.querySelector('[data-error]'), result.message); }
          yes.disabled = false;
          refund = result.refund;
          yes.textContent = label + ' · refund ' + money(result.refund);
        });
      }

      all.querySelector('[data-toggle]').addEventListener('click', function () {
        var every = order.items.every(function (_, index) { return picked[index]; });
        order.items.forEach(function (_, index) { picked[index] = !every; });
        refresh();
      });
      order.items.forEach(function (_, index) {
        var tile = panel.querySelector('[data-index="' + index + '"]');
        tile.querySelector('[data-toggle]').addEventListener('click', function () { picked[index] = !picked[index]; refresh(); });
        var qty = tile.querySelector('[data-qty]');
        if (qty) qty.addEventListener('change', refresh);
      });
      panel.querySelectorAll('[data-toggle]').forEach(function (head) {
        head.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); head.click(); }
        });
      });
      yes.addEventListener('click', function () {
        var chosen = picks();
        send({ action: 'cancel', items: chosen }, panel.querySelector('[data-error]'), yes, function (result) {
          var whole = chosen.length === order.items.length && chosen.every(function (pick, i) { return pick.quantity === order.items[i].quantity; });
          var count = chosen.reduce(function (sum, pick) { return sum + pick.quantity; }, 0);
          var named = chosen.length === 1 ? (count > 1 ? count + ' × ' : 'the ') + order.items.filter(function (item) { return item.id === chosen[0].id; })[0].title
            : count + ' items';
          cancelled(order, refund, whole ? null : named, result);
        });
      });
    }

    function confirmPanel(panel, order, title, text, label) {
      paint(panel,
        '<div class="swc-cs__card"><strong>' + esc(title) + '</strong>' +
          '<p class="swc-cs__muted">' + esc(text) + '</p>' +
          '<p class="swc-cs__error" data-error hidden></p>' +
          '<div class="swc-cs__actions"><button class="' + PRIMARY + '" type="button" data-yes>' + esc(label) + '</button></div></div>');
      var yes = panel.querySelector('[data-yes]');
      yes.addEventListener('click', function () {
        send({ action: 'cancel' }, panel.querySelector('[data-error]'), yes, function (result) {
          cancelled(order, order.total, null, result);
        });
      });
    }

    function addressPanel(panel, order) {
      var a = order.address || {};
      var name = [a.firstName, a.lastName].filter(Boolean).join(' ');
      paint(panel,
        '<form class="swc-cs__card" data-address><strong>New shipping address</strong>' +
          '<label>Full name<input name="name" autocomplete="name" required value="' + esc(name) + '"></label>' +
          '<label>Street address<input name="address1" autocomplete="address-line1" required></label>' +
          '<label>Apt, suite, etc. (optional)<input name="address2" autocomplete="address-line2"></label>' +
          '<div class="swc-cs__row"><label>City<input name="city" autocomplete="address-level2" required></label>' +
            '<label>State<input name="state" autocomplete="address-level1"></label></div>' +
          '<div class="swc-cs__row"><label>ZIP / postal code<input name="zip" autocomplete="postal-code" required></label>' +
            '<label>Country<input name="country" autocomplete="country-name" value="' + esc(a.countryCodeV2 === 'US' ? 'United States' : '') + '"></label></div>' +
          '<label>Phone (optional)<input name="phone" autocomplete="tel" value="' + esc(a.phone) + '"></label>' +
          '<p class="swc-cs__error" data-error hidden></p>' +
          '<button class="' + PRIMARY + '" type="submit">Send new address</button>' +
        '</form>');
      var form = panel.querySelector('[data-address]');
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var address = {};
        ['name', 'address1', 'address2', 'city', 'state', 'zip', 'country', 'phone'].forEach(function (key) { address[key] = form[key].value; });
        send({ action: 'address', address: address }, form.querySelector('[data-error]'), form.querySelector('button'), function () {
          done('Thanks, we got it', "We'll update the address on " + order.name + ' and confirm by email, usually within one business day.');
        });
      });
    }

    function swapPanel(panel, order) {
      var rows = Array.prototype.slice.call(body.querySelectorAll('[data-swap]'));
      rows.forEach(function (row) {
        row.hidden = false;
        if (row.previousElementSibling.matches('.swc-cs__muted')) row.previousElementSibling.hidden = true;
      });
      paint(panel,
        '<div class="swc-cs__card"><strong>Pick the new size above</strong>' +
          '<p class="swc-cs__muted">Free while your order hasn\'t gone to print. Same price, nothing to pay.</p>' +
          '<p class="swc-cs__error" data-error hidden></p>' +
          '<div class="swc-cs__actions"><button class="' + PRIMARY + '" type="button" data-yes disabled>Swap size</button></div></div>');
      var yes = panel.querySelector('[data-yes]');
      function picks() {
        return rows.map(function (row) {
          var select = row.querySelector('select');
          var item = order.items[Number(row.dataset.swap)];
          return select.value ? { id: item.id, variant_id: select.value, title: item.title, size: select.options[select.selectedIndex].text } : null;
        }).filter(Boolean);
      }
      rows.forEach(function (row) {
        row.querySelector('select').addEventListener('change', function () { yes.disabled = !picks().length; });
      });
      yes.addEventListener('click', function () {
        var chosen = picks();
        send({ action: 'swap', swaps: chosen.map(function (pick) { return { id: pick.id, variant_id: pick.variant_id }; }) },
          panel.querySelector('[data-error]'), yes, function () {
            done('You\'re all set', 'We\'re swapping ' + chosen.map(function (pick) { return pick.title + ' to ' + pick.size; }).join(' and ') +
              ' on ' + order.name + '. Same price, nothing to pay.');
          });
      });
    }

    function remindPanel(panel, order) {
      paint(panel,
        '<div class="swc-cs__card"><strong>It\'s already being made</strong>' +
          '<p class="swc-cs__muted">Once printing starts we can\'t swap sizes or cancel, so it ships as ordered. When it arrives you can exchange it for another size or return it. We\'ll email you the steps the day it\'s delivered.</p>' +
          '<p class="swc-cs__error" data-error hidden></p>' +
          '<button class="' + PRIMARY + '" type="button" data-yes>Email me when it arrives</button></div>');
      var yes = panel.querySelector('[data-yes]');
      yes.addEventListener('click', function () {
        send({ action: 'remind' }, panel.querySelector('[data-error]'), yes, function () {
          done('You\'re all set', 'We\'ll email you how to swap or return ' + order.name + ' the day it\'s delivered.');
        });
      });
    }

    function missingPanel(panel, order) {
      paint(panel,
        '<form class="swc-cs__card" data-missing><strong>' + (order.stage === 'delivered' ? 'Let\'s find your order' : 'Let\'s get it moving') + '</strong>' +
          '<textarea name="message" rows="3" maxlength="2000" aria-label="Anything we should know?" placeholder="Anything we should know? (optional)"></textarea>' +
          '<p class="swc-cs__error" data-error hidden></p>' +
          '<button class="' + PRIMARY + '" type="submit">Send it to us</button>' +
        '</form>');
      var form = panel.querySelector('[data-missing]');
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        send({ action: 'missing', message: form.message.value }, form.querySelector('[data-error]'), form.querySelector('button'), function () {
          done('Thanks, we\'re on it', 'We\'ll check with the carrier and email you within one business day, with a replacement if it\'s lost.');
        });
      });
    }

    function messagePanel(panel) {
      paint(panel,
        '<form class="swc-cs__card" data-message><strong>What would you like to change?</strong>' +
          '<textarea name="message" rows="5" maxlength="5000" required aria-label="What would you like to change?" placeholder="e.g. switch the hoodie to an XL"></textarea>' +
          '<p class="swc-cs__error" data-error hidden></p>' +
          '<button class="' + PRIMARY + '" type="submit">Send</button>' +
        '</form>');
      var form = panel.querySelector('[data-message]');
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        send({ action: 'message', message: form.message.value }, form.querySelector('[data-error]'), form.querySelector('button'), function () {
          done('Thanks, we got it', "We'll reply by email soon, usually within one business day.");
        });
      });
    }

    if (orders.length) renderOrders(); else renderLookup();
  }

  function contactForm(root) {
    var base = root.dataset.api;
    var body = root.querySelector('[data-swc-body]');
    if (root.dataset.reason === 'order_change') orderChange(root, base, body);
    else plainContact(root, base, body);
  }

  function plainContact(root, base, body) {
    api(base, '/v1/config').then(function (config) {
      // A page can open on one reason (the edit/cancel page: order_change), which needs the order number.
      var preset = root.dataset.reason || '';
      var needsOrder = preset === 'order_change';
      paint(body,
        '<form class="swc-cs__card" data-contact>' +
          '<div class="swc-cs__row">' +
            '<label>Name<input name="name" autocomplete="name" value="' + esc(root.dataset.name) + '"></label>' +
            '<label>Email<input name="email" type="email" autocomplete="email" required value="' + esc(root.dataset.email) + '"></label>' +
          '</div>' +
          '<div class="swc-cs__row">' +
            '<label>' + (needsOrder ? 'Order number' : 'Order number (if you have one)') + '<input name="order_number" inputmode="numeric" autocomplete="off"' + (needsOrder ? ' required' : '') + '></label>' +
            '<label>What\'s this about?<select name="reason" required><option value="">Choose one…</option>' +
              config.contact_reasons.map(function (r) { return '<option value="' + esc(r.key) + '"' + (r.key === preset ? ' selected' : '') + '>' + esc(r.label) + '</option>'; }).join('') +
            '</select></label>' +
          '</div>' +
          '<label>Subject<input name="subject" maxlength="200"></label>' +
          '<label>Message<textarea name="message" rows="6" maxlength="5000" required></textarea></label>' +
          '<div class="swc-cs__human" data-human></div>' +
          '<p class="swc-cs__error" data-error hidden></p>' +
          '<button class="global-button global-button--primary" type="submit">Send</button>' +
        '</form>');
      var form = body.querySelector('[data-contact]');
      var human = humanCheck(form.querySelector('[data-human]'), config.turnstile_site_key);
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var errorEl = form.querySelector('[data-error]');
        if (!human.token) return error(errorEl, 'Please finish the quick check above the button.');
        var button = form.querySelector('button');
        button.disabled = true;
        api(base, '/v1/contact', {
          name: form.name.value,
          email: form.email.value,
          order_number: form.order_number.value,
          reason: form.reason.value,
          subject: form.subject.value,
          message: form.message.value,
          turnstile_token: human.token,
        }).then(function (result) {
          button.disabled = false;
          human.reset();
          if (!result.ok) return error(errorEl, result.message);
          paint(body, '<div class="swc-cs__card swc-cs__done"><h2>Thanks, we got it</h2>' +
            '<p>We\'ll reply to ' + esc(form.email.value) + ' soon, usually within one business day.</p></div>');
        });
      });
    });
  }

  document.querySelectorAll('[data-swc-returns]').forEach(returnsPortal);
  document.querySelectorAll('[data-swc-contact]').forEach(contactForm);
})();
